import { render } from "./PagesFooter.vue?vue&type=template&id=4df01baa"
const script = {}

import exportComponent from "C:\\ProjectsLaravel\\nft_imw_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/ts/frontend/components/PagesFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4df01baa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4df01baa', __exports__)) {
    console.log('reload')
    api.reload('4df01baa', __exports__)
  }
  
  module.hot.accept("./PagesFooter.vue?vue&type=template&id=4df01baa", () => {
    console.log('re-render')
    api.rerender('4df01baa', render)
  })

}


export default __exports__